module.exports = __webpack_public_path__ + "img/arrow-right.985bf05d.svg";